import { render, staticRenderFns } from "./SparePartSubCategory.vue?vue&type=template&id=5d2ba9f2"
import script from "./SparePartSubCategory.vue?vue&type=script&lang=ts"
export * from "./SparePartSubCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports